/** Pure form-to-PATCH mapping for the schema-driven device configuration page. */

/** Seed Formik values from the response, ensuring every schema field has a key. */
export function buildDeviceConfigurationInitialValues(config) {
  const values = {};
  (config?.schema?.sections ?? []).forEach(section => {
    values[section.key] = { ...(config?.values?.[section.key] ?? {}) };
    (section.fields ?? []).forEach(field => {
      if (values[section.key][field.name] === undefined) values[section.key][field.name] = '';
    });
  });
  return values;
}

/** Build the sparse section tree accepted by the partial PATCH endpoint. */
export function buildDeviceConfigurationPatchBody(values, initialValues) {
  const body = {};
  Object.keys(values ?? {}).forEach(sectionKey => {
    const section = values[sectionKey] ?? {};
    const initialSection = initialValues?.[sectionKey] ?? {};
    const changed = {};
    Object.keys(section).forEach(fieldName => {
      if (section[fieldName] !== initialSection[fieldName]) changed[fieldName] = section[fieldName];
    });
    if (Object.keys(changed).length > 0) body[sectionKey] = changed;
  });
  return body;
}
